import axios from "axios";
import merge from "lodash/merge";
import { LOCATION_CHANGE } from "react-router-redux";
import { deepCloneAndOmitAtPath } from "../../helpers/state";
import * as userActionConstants from "./constants";
import * as userActionTypes from "./types";

const initialState = {
    authRequired: true,
    userId: null,
    teamId: null,
    authToken: null,
    isShareLink: false,
    [userActionConstants.LOGIN_PAGE_KEY]: null
};

const session = (state = initialState, action) => {
    switch (action.type) {
        case LOCATION_CHANGE:
            const isShareLink =
                action.payload.pathname.split("/", 2)[1] === "shared";
            return {
                ...state,
                isShareLink
            };

        case userActionTypes.CLEAR_STATUS_STATE:
            return deepCloneAndOmitAtPath(state, action.removalPath);

        case userActionTypes.REQUEST_USER_AUTH:
            return merge({}, state, {
                [userActionConstants.LOGIN_PAGE_KEY]: {
                    status: action.type,
                    attemptedEmail: action.email,
                    isLoading: true
                }
            });

        case userActionTypes.USER_AUTH_ERROR:
            return merge({}, state, {
                [userActionConstants.LOGIN_PAGE_KEY]: {
                    status: action.type,
                    error: action.error,
                    errorMessage: action.errorMessage,
                    isLoading: false
                }
            });

        case userActionTypes.USER_AUTH_SUCCESS:
            // TODO we should only do this if the "remember me" button is checked
            localStorage.setItem("AUTHED_WEVO_USER", JSON.stringify(action));
            axios.defaults.headers.common["Authorization"] = `Bearer ${
                action.session.authToken
            }`;
            return {
                ...state,
                ...action.session,
                authRequired: false,
                [userActionConstants.LOGIN_PAGE_KEY]: null
            };

        case userActionTypes.RESET_AUTH:
            localStorage.removeItem("AUTHED_WEVO_USER");
            delete axios.defaults.headers.common["Authorization"];
            return merge({}, state, initialState);

        default:
            return state;
    }
};

export default session;



// WEBPACK FOOTER //
// ./src/modules/session/reducers.js